import React from 'react';
import { RHFTextField } from '@talentmesh/forms';
import ApplicantInformationType from '../../../../../../Models/ApplicantInformationType';
import Constants from '../Constants';
import useTMTranslation from '../../../../../../Hooks/useTMTranslation';

function ReasonForApplying(): React.JSX.Element {
    const { tCommon: t } = useTMTranslation();

    return (
        <RHFTextField
            multiline
            fullWidth
            label={`${t('ReasonForApplying')}*`}
            name={ApplicantInformationType.ReasonForApplying}
            rows={Constants.numberOfRows}
            maxChar={Constants.textFieldLargeCapacity}
        />
    );
}

export default ReasonForApplying;
